import React from 'react';

import type { TypeMultiToggleItem } from 'js/src/components/common/ui/MultiToggle';
import MultiToggle, {
    MULTI_TOGGLE_SIZES,
    MULTI_TOGGLE_THEMES,
} from 'js/src/components/common/ui/MultiToggle';

type Props = {
    monthly: boolean;
    selectMonthly: VoidFunction;
    selectYearly: VoidFunction;
};

const toggleItems: TypeMultiToggleItem[] = [
    { key: 'monthly', value: 'Monthly' },
    { key: 'yearly', value: 'Yearly (save 25%)', testId: 'yearly-billing-toggle' },
];

const BillingPeriodToggle = React.memo(function BillingPeriodToggle({
    monthly,
    selectMonthly,
    selectYearly,
}: Props) {
    const handleSelect = React.useCallback(
        (selectedKey: string) => {
            if (selectedKey === 'monthly') {
                selectMonthly();
            } else {
                selectYearly();
            }
        },
        [selectMonthly, selectYearly],
    );

    return (
        <MultiToggle
            items={toggleItems}
            selectedItem={monthly ? 'monthly' : 'yearly'}
            onSelect={handleSelect}
            theme={MULTI_TOGGLE_THEMES.PRIMARY}
            size={MULTI_TOGGLE_SIZES.LG}
        />
    );
});

export default BillingPeriodToggle;
